module.exports = __webpack_public_path__ + "static/media/dubhacks2019.80856403.jpg";